import { Box, Button, Heading, HStack, VStack } from "components/ui";
import { getHelpVideoUrl } from "config/helpVideos";
import { useTranslation } from "hooks/useTranslation";
import { getThemeColor } from "theme/colors";

interface Step0OverviewProps {
  onNext: () => void;
}

export const Step0Overview = ({ onNext }: Step0OverviewProps) => {
  const { t } = useTranslation();

  return (
    <Box position="relative" h="full" display="flex" flexDirection="column">
      {/* Scrollable Content */}
      <Box
        flex="1"
        overflowY="auto"
        px={6}
        py={4}
        display="flex"
        alignItems="center"
      >
        <VStack gap={6} align="stretch" w="full">
          {/* Video Section */}
          <Box w="full">
            <Heading
              size="sm"
              mb={4}
              textAlign="center"
              color={getThemeColor("text.primary")}
            >
              {t("app.onboarding.step0.videoTitle")}
            </Heading>
            <Box
              mx="auto"
              w="full"
              maxW="1200px"
              borderRadius="lg"
              overflow="hidden"
              boxShadow="lg"
              bg={getThemeColor("bg.tertiary")}
              position="relative"
              paddingBottom="56.25%"
            >
              <iframe
                src={`https://www.youtube.com/embed/${getHelpVideoUrl("onboarding.step0.overview")}`}
                style={{
                  border: "none",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                allowFullScreen
                title={t("app.onboarding.overview.videoTitle")}
              />
            </Box>
          </Box>
        </VStack>
      </Box>

      {/* Sticky Footer */}
      <Box
        position="sticky"
        bottom={0}
        borderTopWidth="1px"
        borderColor={getThemeColor("border.default")}
        bg={getThemeColor("modal.bg")}
        py={4}
        px={6}
        boxShadow="sm"
      >
        <HStack justify="flex-end">
          <Button size="md" colorPalette="blue" onClick={onNext}>
            {t("app.onboarding.step0.getStarted")}
          </Button>
        </HStack>
      </Box>
    </Box>
  );
};
